<template>
  <button class="hamburger" type="button" @click.prevent="$emit('click', $event)">
    <svg class="o-icon">
      <use xlink:href="#md-menu" v-if="!isActive"></use>
      <use xlink:href="#close" v-else></use>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'HamburgerButton',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>
